<template>
    <v-container fluid class="py-0 my-0">
        <v-row style="background-color: teal;" class="my-0 py-0">
            <v-col cols="12" align="center">
                <div class="white--text cup-title">{{ cupLeagueTitle }}</div>
            </v-col>
        </v-row>
        <v-row class="mt-0 pt-0">
            <v-col cols="12" class="mx-0 px-0 mt-0 pt-0">
                <v-tabs
                    v-model="tab"
                    centered
                    class="rounded"
                    background-color="#232323"
                >
                    <v-tabs-slider class="custom-teal" />
                    <v-tab v-for="(item, index) in items" :key="index" style="font-size: 25px;">{{ item.name }}</v-tab>
                </v-tabs>
            </v-col>
        </v-row>
        <cup-bracket-board
            v-if="tab === 0"
            :loading="loading"
            :error-message="errorMessage"
            :matches="matches"
        />
        <schedule-league v-else-if="tab === 1" :class="$vuetify.breakpoint.mobile ? '' : 'px-16'" :matches="matches" />
        <league-stats v-else-if="tab === 2" :class="$vuetify.breakpoint.mobile ? '' : 'px-16'" :type="'cup'" :league="cupLeague" :season="seasonId" />
    </v-container>
</template>

<script>
    import CupBracketBoard from '@/components/CupBracketBoard'
    import leagueService from '@/services/league'
    import matchService from '@/services/match'
    import ScheduleLeague from '@/components/ScheduleAlternative'
    import LeagueStats from '@/components/LeagueStats'

    export default {
        components: { CupBracketBoard, ScheduleLeague, LeagueStats },
        data() {
            return {
                loading: false,
                errorMessage: '',
                cupLeagueTitle: 'Cup League',
                cupLeague: null,
                matches: [],
                tab: null,
                seasonId: null,
                items: [
                    {
                        name: 'Standings'
                    },
                    {
                        name: 'Match Center'
                    },
                    {
                        name: 'Statistics'
                    }
                ]
            }
        },
        watch: {
            '$route.params.id': {
                handler() {
                    this.loadCupLeagueTree()
                }
            }
        },
        created() {
            this.loadCupLeagueTree()
            this.seasonId = this.$store.getters.getConfig?.activeSeasonId || null
        },
        methods: {
            async loadCupLeagueTree() {
                this.loading = true
                this.errorMessage = ''
                this.cupLeagueTitle = 'Cup League'
                this.matches = []

                try {
                    const cupLeagueId = Number(this.$route.params.id)
                    const seasonId = this.$store.getters.getConfig?.activeSeasonId

                    if (!seasonId) {
                        this.errorMessage = 'Δεν βρέθηκε ενεργή σεζόν στη ρύθμιση του συστήματος.'
                        return
                    }

                    if (!cupLeagueId) {
                        this.errorMessage = 'Μη έγκυρο Cup League id.'
                        return
                    }

                    const cupLeagueResp = await leagueService.getCupLeague(cupLeagueId)
                    this.cupLeague = cupLeagueResp?.data || {}
                    this.cupLeagueTitle = this.cupLeague.title || this.cupLeague.name || this.cupLeagueTitle

                    const filters = { cup: `{isCup: true, season: ${seasonId}, cupLeague: ${cupLeagueId}}` }
                    const matchesResp = await matchService.getMatches(1, 1000, filters)
                    const seasonCupMatches = matchesResp?.data?.content || []

                    const currentCupLeagueMatches = seasonCupMatches.filter(match => {
                        const matchCupLeagueId = Number(match?.cupLeague?.id || match?.cupLeagueId || match?.cup_league_id || 0)

                        // If backend already filtered and relation is not populated, keep the match.
                        if (!matchCupLeagueId) return true
                        return matchCupLeagueId === cupLeagueId
                    })

                    this.matches = currentCupLeagueMatches
                } catch (error) {
                    this.errorMessage = 'Αποτυχία φόρτωσης αγώνων Cup League.'
                } finally {
                    this.loading = false
                }
            }
        }
    }
</script>

<style scoped>
    .cup-title {
        font-size: 50px;
        padding-left: 10px;
        margin: 0;
    }
</style>
